import React from 'react'
import { useIntl } from 'react-intl'

import PriceLayout, { FeaturedPrice } from '../../../PriceLayout'
import { OfferPriceProps } from '..'

const OfferPriceNet = ({
  board,
  nights,
  priceData,
  prime = false,
  showDiscount,
  showDiscountBadge,
  showSubtitle,
  showFrom,
  loading = false,
  className,
}: OfferPriceProps) => {
  const intl = useIntl()

  const {
    currency,
    discount,
    pricePerNightSubtotal,
    initialPrice,
    finalPrice,
    taxDetails,
    additionalFees,
    insuranceSelected,
  } = board

  return (
    <PriceLayout
      className={className}
      currency={currency}
      discount={discount}
      pricePerNight={pricePerNightSubtotal}
      priceInitial={initialPrice}
      priceFinal={finalPrice}
      vats={intl.formatMessage({ id: 'global.vat-included' })}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      nights={nights}
      featuredPrice={FeaturedPrice.PerNight}
      loading={loading}
      showSubtitle={showSubtitle}
      taxDetails={taxDetails}
      additionalFees={additionalFees}
      insuranceSelected={insuranceSelected}
    />
  )
}

export default OfferPriceNet
